<template>
  <div class="ocr-sidebar-skeleton">
    <div class="ocr-context-bar ocr-context-bar--sidebar ocr-context-bar--skeleton">
      <div class="ocr-context-fields">
        <OcrSkLine width="48px" height="11px" class="ocr-sk-label" />
        <OcrSkLine block height="40px" round class="ocr-sk-field" />
      </div>
      <div class="ocr-context-actions ocr-context-actions--stacked">
        <OcrSkLine width="64px" height="32px" pill />
        <OcrSkLine width="72px" height="32px" pill />
      </div>
    </div>
    <nav class="well-top-wrap ocr-tabs-bar ocr-sidebar-nav" aria-hidden="true">
      <div class="tabs-data">
        <div class="tabs-toggle ocr-sidebar-nav-list ocr-sidebar-nav-list--skeleton">
          <div
            v-for="n in 5"
            :key="n"
            class="ocr-sidebar-nav-skeleton-row"
            :class="{ 'ocr-sidebar-nav-skeleton-row--active': n === 1 }"
          >
            <OcrSkLine :width="navWidths[n - 1]" height="14px" class="ocr-sk-nav-label" />
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import OcrSkLine from "@/components/layout/OCR/OcrSkLine.vue";

export default {
  name: "OcrSidebarSkeleton",
  components: { OcrSkLine },
  data() {
    return {
      navWidths: ["88px", "92px", "118px", "108px", "78px"],
    };
  },
};
</script>
